import { Component, inject } from '@angular/core';
import { CardModule } from '@primeng/card';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Table } from '@primeng/table';
import { first } from 'rxjs';
import { NgFooterTemplateDirective } from '@ng-select/ng-select';
import { ModalService } from '@shared/services/modal/modal.service';
import {
  AddPersonComponent
} from '@modules/universal-billing/properties/property-profile/tabs/object-resposible/add-person/add-person.component';
import {LowerCasePipe} from '@angular/common';

@Component({
  selector: 'app-property-maintenance',
  standalone: true,
  imports: [
    CardModule,
    TranslatePipe,
    Table,
    NgFooterTemplateDirective,
    LowerCasePipe
  ],
  templateUrl: './property-maintenance.component.html',
  styleUrl: './property-maintenance.component.scss'
})
export class PropertyMaintenanceComponent {
  modalService = inject(ModalService);
  translate = inject(TranslateService);

  maintenanceContracts = [
    {
      title: 'Heizungsreparatur',
      status: 'Abgeschlossen',
      date: '2023-10-15T09:00:00Z',
      assigned: 'Heizungsservice Schmidt',
    },
  ];

  inProcess() {
    this.modalService.open({
      component: AddPersonComponent,
      title: this.translate.instant('ADD'),
      componentOptions: {},
      modalOptions: {
        size: 'sm',
      }
    })
  }
}
